import { render, staticRenderFns } from "./FormEscolas.vue?vue&type=template&id=794ee65d"
import script from "./FormEscolas.vue?vue&type=script&lang=js"
export * from "./FormEscolas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports